module.exports = __webpack_public_path__ + "img/cheese.be5030ca.webp";